/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

export type MapLocationKind = typeof MapLocationKind[keyof typeof MapLocationKind];


export const MapLocationKind = {
  reported: 'reported',
  inferred_from_serviceable_footprint: 'inferred_from_serviceable_footprint',
} as const;
